let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hPmxZ")).then(() => parcelRequire('f7OYW'));